// Как поступать при выходе из полноэкранного режима и из режима картинка-в-картинке на iOS
// - unpause — пытаться снять видео с паузы
// - reload — перезагружать страницу
const RESUME_PLAY_METHOD: "reload" | "unpause" = "reload";

export function isSafariOnIOS(): boolean {
    const ua = window.navigator.userAgent;
    const iOS = /iPad/i.test(ua) || /iPhone/i.test(ua);
    const webkit = /WebKit/i.test(ua);

    return iOS && webkit && !ua.match(/CriOS/i);
}

export function resumePlay(video: HTMLVideoElement) {
    if (RESUME_PLAY_METHOD === "reload") {
        const sp = new URLSearchParams(document.location.search);
        sp.set("rt", `${Math.random() * 10000}`);
        document.location.search = sp.toString();
        return;
    }

    // Дикий хак для Safari на iOS.
    // Два раза снимаем видео с паузы, чтобы оно продолжило проигрывание после выхода из режимов картинка-в-картинке и полного экрана

    const playAgain = () => {
        $(video).one("pause", () => video.play().catch(e => console.error(e)));
        setTimeout(() => video.play().catch(e => console.error(e)), 0);
    };
    if (video.paused) {
        playAgain();
    } else {
        $(video).one("pause", playAgain);
    }
}
